"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const filter_1 = __importDefault(require("lodash/filter"));
const find_1 = __importDefault(require("lodash/find"));
const fromPairs_1 = __importDefault(require("lodash/fromPairs"));
const get_1 = __importDefault(require("lodash/get"));
const groupBy_1 = __importDefault(require("lodash/groupBy"));
const keyBy_1 = __importDefault(require("lodash/keyBy"));
const keys_1 = __importDefault(require("lodash/keys"));
const map_1 = __importDefault(require("lodash/map"));
const mapKeys_1 = __importDefault(require("lodash/mapKeys"));
const orderBy_1 = __importDefault(require("lodash/orderBy"));
const size_1 = __importDefault(require("lodash/size"));
const toPairs_1 = __importDefault(require("lodash/toPairs"));
const mobx_1 = require("mobx");
const getBranchList_1 = __importDefault(require("../clients/branch/getBranchList"));
const API_STATE_1 = __importDefault(require("../constants/app/API_STATE"));
const branchFactory_1 = __importDefault(require("../factories/branch/branchFactory"));
const getBranchNotFound_1 = __importDefault(require("../utils/error/getBranchNotFound"));
const mapInitialStateToStoreState_1 = __importDefault(require("../utils/store/mapInitialStateToStoreState"));
/**
 * Branch Domain Store
 * Stores a list of car rental branches.
 */
class BranchStore {
    constructor(initialState, $env) {
        this.data = [];
        this.apiState = API_STATE_1.default.INITIAL;
        this.errorData = {};
        this.searchType = '';
        /**
         * Returns branches for a regionId
         * @returns {Array}
         */
        this.getBranchesByRegionId = (regionId) => {
            return this.branchRegionIdHashMap[regionId];
        };
        /**
         * Returns region name for a given regionId
         * @returns {string}
         */
        this.getRegionNameByRegionId = (regionId) => {
            return this.branchRegionIdHashMap[regionId][0].regionName;
        };
        /**
         * Returns branch for passed id
         * @param {number} branchId
         * @returns {object} selectedBranch
         */
        this.getBranchById = (branchId) => {
            const selectedBranch = (0, find_1.default)(this.branchList, {
                id: branchId,
            });
            return selectedBranch;
        };
        /**
         * Returns branch name for passed id
         * @param {number} branchId
         * @returns {string} branch name if found
         * @returns "" if branch not found
         */
        this.getBranchNameById = (branchId) => {
            const filteredBranchArr = (0, filter_1.default)(this.branchList, { id: branchId });
            return (0, get_1.default)(filteredBranchArr, '0.name', '');
        };
        /**
         * Returns branches for a city ID
         * @param {number} cityId
         * @returns {Array}
         */
        this.getBranchesByCityId = (cityId) => {
            return this.cityIdHashMap[cityId];
        };
        /**
         * Constructs the fetch query object
         * @param searchText {string}
         * @returns {object}
         */
        this.getQueryObj = (searchText, lat, long) => {
            const queryData = {
                sort: 'distance', // usually this will come from app side
            };
            // to-do: see if there is better way using lodash
            if (searchText) {
                queryData.query = searchText;
            }
            if (lat) {
                queryData.latitude = lat;
            }
            if (long) {
                queryData.longitude = long;
            }
            return queryData;
        };
        /**
         * Fetches Branch data from backend
         * @param searchText {string}
         * @param endPoint {string}
         * @param errorHandler {function}
         * @param searchType {string}
         */
        this.fetch = (0, mobx_1.flow)(function* (searchText = '', lat = 0, long = 0, errorHandler, searchType = '') {
            try {
                if (this.apiState !== API_STATE_1.default.SUCCESS) {
                    this.data = [];
                }
                this.apiState = API_STATE_1.default.LOADING;
                this.errorData = {};
                this.searchType = searchType;
                const searchQuery = this.getQueryObj(searchText, lat, long);
                const branchResponse = yield (0, getBranchList_1.default)(searchQuery);
                const { data, total } = branchResponse;
                // for no data (0) response comes back with only total
                if (total < 1) {
                    // throw custom error
                    const errObj = (0, getBranchNotFound_1.default)();
                    this.onError(errObj, errorHandler);
                }
                else {
                    this.onSuccess(data);
                }
            }
            catch (err) {
                this.onError(err, errorHandler);
            }
        });
        /**
         * on success callback
         * @param data
         */
        this.onSuccess = (data) => {
            this.data = data;
            this.apiState = API_STATE_1.default.SUCCESS;
        };
        /**
         * on error callback
         * @param err
         * @param errorHandler
         */
        this.onError = (err, errorHandler) => {
            this.apiState = API_STATE_1.default.FAILED;
            // when a request is cancelled, Axios promise is rejected
            if (err.response) {
                // && !axios.isCancel(err)
                const errResponse = err.response;
                const { data, status } = errResponse;
                // stores axios error info in observable
                this.errorData = {
                    data,
                    status,
                };
                if (errorHandler) {
                    errorHandler(errResponse);
                }
            }
        };
        /**
         * Action to set initial state
         */
        this.setInitialState = () => {
            this.apiState = API_STATE_1.default.INITIAL;
            this.data = [];
            this.errorData = {};
        };
        /**
         * Map initial state to store state
         * @param initialState
         */
        this.updateInitialState = (initialState) => {
            (0, mapInitialStateToStoreState_1.default)(this, initialState);
        };
        this.$env = $env;
        this.updateInitialState(initialState);
    }
    /**
     * Returns the loading status
     * @returns {Boolean}
     */
    get isLoading() {
        return this.apiState === API_STATE_1.default.LOADING;
    }
    /**
     * Returns if API fetch was success
     * @returns {Boolean}
     */
    get isSuccess() {
        return this.apiState === API_STATE_1.default.SUCCESS;
    }
    /**
     * Returns if API fetch has failed
     * @returns {Boolean}
     */
    get hasFailed() {
        return this.apiState === API_STATE_1.default.FAILED;
    }
    /**
     * Returns true if API fetch returned no data
     * @returns {Boolean}
     */
    get hasNoData() {
        return (this.isSuccess || this.hasFailed) && this.count === 0;
    }
    /**
     * Returns formatted Branch List
     * @returns {Array<BranchType>}
     */
    get branchList() {
        return (0, map_1.default)(this.data, (branch) => (0, branchFactory_1.default)(branch, this.language));
    }
    /**
     * Returns pick-up Branch List
     * @returns {Array<BranchFactoryType>}
     */
    get pickUpBranchList() {
        return (0, filter_1.default)(this.branchList, (branch) => !(0, get_1.default)(branch, 'carDelivery', false));
    }
    /**
     * Returns Car delivery Branch List
     * @returns {Array<BranchFactoryType>}
     */
    get carDeliveryBranchList() {
        return (0, filter_1.default)(this.branchList, (branch) => (0, get_1.default)(branch, 'carDelivery', false));
    }
    /**
     * Returns an object hashmap of branches by regionId
     * @returns {Object}
     */
    get branchRegionIdHashMap() {
        return (0, groupBy_1.default)(this.branchList, 'regionId');
    }
    /**
     * Returns an array of regionId's
     * @returns {Array}
     */
    get branchRegionList() {
        return (0, keys_1.default)(this.branchRegionIdHashMap);
    }
    /**
     * Returns total branch count
     * @returns {Number}
     */
    get count() {
        return (0, size_1.default)(this.branchList);
    }
    /**
     * Returns current config language
     * @returns {LANG_VALUES}
     */
    get language() {
        return this.$env.config.locale;
    }
    /**
     * Returns branches grouped by cities
     */
    get cityIdHashMap() {
        return (0, groupBy_1.default)(this.branchList, 'cityId');
    }
    /**
     * Returns PickUp branches grouped by cities
     */
    get cityIdPickUpHashMap() {
        return (0, groupBy_1.default)(this.pickUpBranchList, 'cityId');
    }
    /**
     * Returns Delivery branches grouped by cities
     */
    get cityIdDeliveryHashMap() {
        return (0, groupBy_1.default)(this.carDeliveryBranchList, 'cityId');
    }
    /**
     * Returns an object hashmap of branches by branchId
     * @returns {Object}
     */
    get branchHashMap() {
        return (0, keyBy_1.default)(this.branchList, 'id');
    }
    /**
     * Returns branches grouped by cities
     * sorted by distance
     */
    get sortedCityIdHashMap() {
        const updatedKeyObj = (0, mapKeys_1.default)(this.cityIdHashMap, (value) => {
            return `city_${value[0].distance}`;
        });
        const pairs = (0, toPairs_1.default)(updatedKeyObj);
        const sorted = (0, orderBy_1.default)(pairs, (value) => {
            return value[1][0].distance;
        });
        return (0, fromPairs_1.default)(sorted);
    }
    /**
     * Returns Delivery branches grouped by cities
     * sorted by distance
     */
    get sortedDeliveryCityIdHashMap() {
        const updatedKeyObj = (0, mapKeys_1.default)(this.cityIdDeliveryHashMap, (value) => {
            return `city_${value[0].distance}`;
        });
        const pairs = (0, toPairs_1.default)(updatedKeyObj);
        const sorted = (0, orderBy_1.default)(pairs, (value) => {
            return value[1][0].distance;
        });
        return (0, fromPairs_1.default)(sorted);
    }
    /**
     * Returns Delivery branches grouped by cities
     * sorted by distance
     */
    get sortedPickUpCityIdHashMap() {
        const updatedKeyObj = (0, mapKeys_1.default)(this.cityIdPickUpHashMap, (value) => {
            return `city_${value[0].distance}`;
        });
        const pairs = (0, toPairs_1.default)(updatedKeyObj);
        const sorted = (0, orderBy_1.default)(pairs, (value) => {
            return value[1][0].distance;
        });
        return (0, fromPairs_1.default)(sorted);
    }
}
__decorate([
    mobx_1.observable
], BranchStore.prototype, "data", void 0);
__decorate([
    mobx_1.observable
], BranchStore.prototype, "apiState", void 0);
__decorate([
    mobx_1.observable
], BranchStore.prototype, "errorData", void 0);
__decorate([
    mobx_1.observable
], BranchStore.prototype, "searchType", void 0);
__decorate([
    mobx_1.computed
], BranchStore.prototype, "isLoading", null);
__decorate([
    mobx_1.computed
], BranchStore.prototype, "isSuccess", null);
__decorate([
    mobx_1.computed
], BranchStore.prototype, "hasFailed", null);
__decorate([
    mobx_1.computed
], BranchStore.prototype, "hasNoData", null);
__decorate([
    mobx_1.computed
], BranchStore.prototype, "branchList", null);
__decorate([
    mobx_1.computed
], BranchStore.prototype, "pickUpBranchList", null);
__decorate([
    mobx_1.computed
], BranchStore.prototype, "carDeliveryBranchList", null);
__decorate([
    mobx_1.computed
], BranchStore.prototype, "branchRegionIdHashMap", null);
__decorate([
    mobx_1.computed
], BranchStore.prototype, "branchRegionList", null);
__decorate([
    mobx_1.computed
], BranchStore.prototype, "count", null);
__decorate([
    mobx_1.computed
], BranchStore.prototype, "language", null);
__decorate([
    mobx_1.computed
], BranchStore.prototype, "cityIdHashMap", null);
__decorate([
    mobx_1.computed
], BranchStore.prototype, "cityIdPickUpHashMap", null);
__decorate([
    mobx_1.computed
], BranchStore.prototype, "cityIdDeliveryHashMap", null);
__decorate([
    mobx_1.computed
], BranchStore.prototype, "branchHashMap", null);
__decorate([
    mobx_1.computed
], BranchStore.prototype, "sortedCityIdHashMap", null);
__decorate([
    mobx_1.computed
], BranchStore.prototype, "sortedDeliveryCityIdHashMap", null);
__decorate([
    mobx_1.computed
], BranchStore.prototype, "sortedPickUpCityIdHashMap", null);
__decorate([
    mobx_1.action.bound
], BranchStore.prototype, "onSuccess", void 0);
__decorate([
    mobx_1.action.bound
], BranchStore.prototype, "onError", void 0);
__decorate([
    mobx_1.action.bound
], BranchStore.prototype, "setInitialState", void 0);
__decorate([
    mobx_1.action.bound
], BranchStore.prototype, "updateInitialState", void 0);
exports.default = BranchStore;
